import privateAxios from '../../helpers/private.axios'
import config from '../../config'

export const GET_EXPERT_CONTESTS_REQ ='GET_EXPERT_CONTESTS_REQ'
export const GET_EXPERT_CONTESTS_RES ='GET_EXPERT_CONTESTS_RES'
export const GET_EXPERT_CONTESTS_ERR ='GET_EXPERT_CONTESTS_ERR'

export const LOTS_REGISTER_REQ ='LOTS_REGISTER_REQ'
export const LOTS_REGISTER_RES ='LOTS_REGISTER_RES'
export const LOTS_REGISTER_ERR ='LOTS_REGISTER_ERR'

export const CLEAR_LOTS_REGISTER ='CLEAR_LOTS_REGISTER'
export const CLEAR_EXPERT_CONTESTS ='CLEAR_EXPERT_CONTESTS'

export const getExpertContests = (id) => (dispatch) => {
  dispatch({ type: GET_EXPERT_CONTESTS_REQ })

  privateAxios(`${config.apiPath}/api/catalogs/contests/${id}/experts`)
  .then( res => {
    dispatch({
      type: GET_EXPERT_CONTESTS_RES,
      payload: res.data.data
    })
  })
  .catch( err => {
    dispatch({
      type: GET_EXPERT_CONTESTS_ERR,
      payload: err
    })
  })
}

export const clearExpertContests = () => (dispatch) => {
  dispatch({ type: CLEAR_EXPERT_CONTESTS })
}